/**
 * Helper to help execute multiple function in HOF way
 *
 * @remarks
 * [HOF](https://www.freecodecamp.org/news/higher-order-functions-in-javascript/)
 *
 * @param fns - Array of function that need to be executed
 *
 * @returns method - function to execute all fn that is passed
 *
 * @example
 * ```tsx
 *
 * const ExtendComponent = (props: ExtendComponentProps) => {
 *   const {onClick, ...resProps} = props;
 *
 *   function defaultOnClick() {
 *     // some code
 *   }
 *
 *   return <Component onClick={callAllFn(defaultOnClick, onClick)} {...resProps}/>
 * }
 *
 * ```
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const callAllFn = // This arguments received function with diverse type that can't be define in type
// eslint-disable-next-line @typescript-eslint/ban-types
function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return fns.forEach((fn)=>fn?.(...args));
    };
};
const _default = callAllFn;
